var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({staticClass:"action-icons action-icons__copy-icon",attrs:{"size":"22","color":"mainGrey"},on:{"click":function($event){$event.stopPropagation();return _vm.$emit('copyContent')}}},on),[_vm._v(" mdi-content-copy ")])]}}])},[_c('span',[_vm._v("Copy content")])])}
var staticRenderFns = []

export { render, staticRenderFns }